import React, { useMemo, useState } from "react";
import CommonButton from "../../common/button/button";
import Tags from "../../common/tags/index.js";
import "./ProductGroupCards.css";

const getProductGroupTags = (group) => [
  { value: group.Serialized, trueText: "Serialized", falseText: "Non-Serialized" },
  { value: group.IVR, trueText: "IVR Required", falseText: "Non IVR" },
  { value: group.RequireProcedureInfo, trueText: "PI Required", falseText: "Non PI" },
  { value: group.SignatureRequiredForDelivery, trueText: "DS Required", falseText: "Non DS" },
  { value: group.CollectPayment, trueText: "Prepaid", falseText: "Non-Prepaid" },
  { value: group.EnableOpenOrder, trueText: "Open Order", falseText: "TV Order Only" },
];

const parseRate = (rate) => parseFloat(String(rate).replace(/[^0-9.-]+/g, ""));

const ProductGroupCards = ({ productGroups, canEdit, onView, onEdit }) => {
  const [query, setQuery] = useState("");

  const visibleGroups = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return productGroups;
    return productGroups.filter((group) =>
      [group.ProductGroupName, group.QCode].some((value) =>
        String(value ?? "").toLowerCase().includes(q)
      )
    );
  }, [productGroups, query]);

  return (
    <div>
      <div className="pg-cards-toolbar">
        <input
          className="pg-cards-search"
          type="search"
          aria-label="Search product groups"
          placeholder="Search by name or HCPCS code"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </div>

      {visibleGroups.length === 0 ? (
        <div className="pg-cards-empty">No product groups found</div>
      ) : (
        <div className="pg-cards-grid">
          {visibleGroups.map((group) => {
            const rate = parseRate(group.Rate);
            return (
              <article
                key={group.ID ?? group.ProductGroupName}
                className={`pg-card ${group.IsActive ? "" : "pg-card--inactive"}`}
              >
                <div className="pg-card__head">
                  <div className="pg-card__name">
                    <CommonButton variant="link" onClick={() => onView(group)}>
                      {group.ProductGroupName}
                    </CommonButton>
                  </div>
                  <Tags
                    textColor={group.IsActive ? "successColorDark" : "failureColorDark"}
                    tagBackground={group.IsActive ? "successColorLight" : "failureColorLight"}
                    tagText={group.IsActive ? "Active" : "Inactive"}
                  />
                </div>

                <div className="pg-card__pricing">
                  <span className="pg-card__rate">
                    {Number.isNaN(rate) ? "—" : `$${rate.toLocaleString()}`}
                  </span>
                  <span className="pg-card__rate-type">
                    {group.PricingType === "custom" ? "Custom Pricing" : "Rate Based"}
                  </span>
                  <span className="pg-card__code">HCPCS {group.QCode || "—"}</span>
                </div>

                <div className="pg-card__tags">
                  {getProductGroupTags(group).map((tag) => (
                    <Tags
                      key={tag.trueText}
                      size="small"
                      textColor={tag.value ? "successColorDark" : "failureColorDark"}
                      tagBackground={tag.value ? "successColorLight" : "failureColorLight"}
                      tagText={tag.value ? tag.trueText : tag.falseText}
                    />
                  ))}
                </div>

                {canEdit && (
                  <div className="pg-card__foot">
                    <CommonButton variant="table" subVariant="warning" onClick={() => onEdit(group)}>
                      Edit
                    </CommonButton>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProductGroupCards;
